// extracted by mini-css-extract-plugin
export var fadePop = "TabsContainer-module--fade-pop--5c375";
export var growHeightIn = "TabsContainer-module--grow-height-in--0b2c6";
export var noUnderline = "TabsContainer-module--noUnderline--3f4fb";
export var underline = "TabsContainer-module--underline--30ead";